import { http } from '@/lib/http';
import type { APIResponse } from '@/types';

type PostCartReorderParams = {
  printId: number;
};

type PostCartReorderResponse = APIResponse<{
  userPrintId: number;
  cartItemId: number;
}>;

export const postCartReorder = async (params: PostCartReorderParams) => {
  return await http<PostCartReorderResponse>('/user/v1/gf/cart/reorder', {
    method: 'POST',
    body: JSON.stringify({
      print_id: params.printId,
    }),
  });
};
